/* global addCompanyViewURL, mapDesc, mapStates, mapUrlPrefix, twttr, FB -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import { initLightbox } from '@common/lightbox';
import { initMap } from '@common/components/usmap';
import { Swiper } from 'swiper';
import { Pagination } from 'swiper/modules';

const images = [];
let imageIndex;
let currentSlide;

const initImages = () => {
    $('.swiper > .swiper-wrapper')
        .children('.swiper-slide:not(.video-slider,.swiper-slide-duplicate)')
        .each(function () {
            images.push($(this).index());
        });
};

// Removing all required data placeholder
const stI = document.getElementById('st-i');
stI.parentElement.removeChild(stI);

//usmap.
if (document.getElementById('company_map')) {
    const state_specific = {};
    const states = JSON.parse(document.getElementById('company_map').dataset.source);

    for (const i in states) {
        if (!Object.prototype.hasOwnProperty.call(states, i)) {
            continue;
        }
        const state = states[i];
        const target = document.getElementById(`state-${state.abbreviation}`);
        if (target !== null) {
            state_specific[state.abbreviation] = {
                name: state.name,
                description: target.getAttribute('title'),
                url: target.getAttribute('href'),
            };
        } else {
            const companyName = document.getElementById('company-name').textContent;
            state_specific[state.abbreviation] = {
                name: state.name,
                description: `${companyName} is not currently hiring in ${state.name}`,
                color: '#b3b3b3',
                hover_color: '#b3b3b3',
                url: '',
            };
        }
    }

    initMap('company_map', mapStates, mapDesc, mapUrlPrefix, 800, state_specific);
}
//photo
$('.goto-photo').click(function () {
    // clients are not required to have photos it seems
    const $photoSelector = $("[name='photo']");
    if ($photoSelector.length === 0) {
        return;
    }
    if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        $('body, html').animate({
            scrollTop: $photoSelector.offset().top,
        }, 500);
    } else {
        $('body, html').animate({
            scrollTop: $photoSelector.offset().top - 164,
        }, 500);
    }
});

//job
$('.goto-job').click(function () {
    if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        $('body, html').animate({
            scrollTop: $("[name='jobs']").offset().top,
        }, 500);
    } else {
        $('body, html').animate({
            scrollTop: $("[name='jobs']").offset().top - 164,
        }, 500);
    }
});

//review
$('.goto-reviews').click(function () {
    if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        $('body, html').animate({
            scrollTop: $("[name='review']").offset().top,
        }, 500);
    } else {
        $('body, html').animate({
            scrollTop: $("[name='review']").offset().top - 164,
        }, 500);
    }
});

//about
$('.goto-profile').click(function () {
    if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        $('body, html').animate({
            scrollTop: $("[name='profile']").offset().top,
        }, 500);
    } else {
        $('body, html').animate({
            scrollTop: $("[name='profile']").offset().top - 164,
        }, 500);
    }
});

$(document).ready(function () {
    addCompanyView();
    initLightbox();

    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
        placement: 'bottom',
    });

    new Swiper('.swiper', {
        modules: [Pagination],
        pagination: {
            el: '.swiper-pagination',
        },
        loop: true,
        height: 380,
        direction: 'horizontal',
    });

    initImages();

    $('.swiper-zoom-container').on('click', function () {
        $('#image-modal-image').attr('src', $(this).children().eq(0).attr('src'));
        $('#image-description').text($(this).children().eq(0).data('description'));
        currentSlide = $(this).parent().index();
        imageIndex = images.indexOf(currentSlide);
        $('#image-current').text(imageIndex + 1);
        $('#image-total').text(images.length);
        $('#image-modal').modal();
    });
    $('#image-modal-left').on('click', function () {
        const $swiperSlide = $('.swiper-slide');
        imageIndex = (imageIndex - 1 + images.length) % images.length;
        currentSlide = images[imageIndex];
        $('#image-modal-image').attr('src', $('img', $swiperSlide.eq(currentSlide)).attr('src'));
        $('#image-description').text($('img', $swiperSlide.eq(currentSlide)).data('description'));
        $('#image-current').text(imageIndex + 1);
    });
    $('#image-modal-right').on('click', function () {
        const $swiperSlide = $('.swiper-slide');
        imageIndex = (imageIndex + 1) % images.length;
        currentSlide = images[imageIndex];
        $('#image-modal-image').attr('src', $('img', $swiperSlide.eq(currentSlide)).attr('src'));
        $('#image-description').text($('img', $swiperSlide.eq(currentSlide)).data('description'));
        $('#image-current').text(imageIndex + 1);
    });

    twttr.ready(
        function (twttr) {
            twttr.events.bind(
                'rendered',
                function () {
                    // Show Twitter widget if no errors
                    if ($('a.twitter-timeline').length === 0) {
                        $('.twitter_timeline_header, #twitter-widget-0, .twitter-timeline, #company-social-widgets').show();
                    }
                },
            );
        },
    );
});

$(document).on('fbloaded', () => {
    FB.Event.subscribe('xfbml.render', () => {
        // Show Facebook widget if no errors
        if ($('.fb_iframe_widget > span').width() > 0) {
            $('.fb_iframe_widget, #company-social-widgets').show();
        }
    });
});

//toggle recruiter list
$('#agency_recruiter_show_all').on('click', function(){
    const btn = $(this);
    switch(btn.html().trim()){
        case 'View All':
            $('.recruiter-list').children().removeClass('d-none');
            btn.html('View Less');
            break;
        case 'View Less':
            $('.recruiter-list').children().slice(4).addClass('d-none');
            btn.html('View All');
            break;
        default:
    }
});

function addCompanyView() {
    return $.post(addCompanyViewURL);
}

$(function () {
    // TODO(derrick): This doesn't belong here.  Extract it to a component and
    // consolidate it with the other usage on job detail.
    $('.faux-accordion').on('click', function () {
        $(this).closest('table').find('tbody').toggle(500);
        $(this).closest('table').find('thead').find('i.chev')
            .toggleClass('mdi-chevron-up')
            .toggleClass('mdi-chevron-down');
        $(this).closest('table').find('thead').find('h3')
            .toggleClass('text-black1')
            .toggleClass('text-black3');
    });
    $('#client-reviews-datatable').DataTable({
        language: {
            emptyTable: 'Be the first to add a review!',
            zeroRecords: 'Be the first to add a review!',
        },

        paging: true,
        bInfo: false,
        bFilter: false,
        ordering: false,
        pageLength: 5,
        lengthChange: false,
        search: false,
        ajax: {
            url: $('#client-reviews-datatable').data('source'),
        },
        columns: [
            {
                name: 'markup',
                data: 'markup',
            },
        ],
    });
});
